import axiosCall from './interceptor';
import URL from '../helper';

export const configureServices = async configData => {
  const url = `${URL.BASE_URL}configAPI`;
  const response = await axiosCall('post', url, configData);
  return response.data;
};


export const getConfiguredServices = async () => {
  const url = `${URL.BASE_URL}configAPI`;
  let response = await axiosCall('get', url);
  return response.data;
};
